// extracted by mini-css-extract-plugin
module.exports = {"grid":"Magazine_grid__9TwXd","dek":"Magazine_dek__2OU3f","imageContainer":"Magazine_imageContainer__CbvIp","button":"Magazine_button__2_9rH"};